module.exports = __webpack_public_path__ + "static/media/chevron-double-right.1604b2a1.svg";